import axios from 'axios'
import { useAppStore } from '../store/useAppStore'
import { useLogStore } from '../store/useLogStore'
import { buildAuthHeader } from '../utils/auth'
import { BACKEND } from '../utils/config'

export const api = axios.create({
  baseURL: BACKEND,
})

// Request Interceptor to add auth header
api.interceptors.request.use((config) => {
  const { credentials } = useAppStore.getState()
  if (credentials) {
    const token = buildAuthHeader(credentials)
    // On n'écrase pas le header s'il est déjà mis manuellement
    if (!config.headers['X-MRC-Auth']) {
      config.headers['X-MRC-Auth'] = token
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// Response Interceptor to log errors globally
api.interceptors.response.use((response) => {
  return response
}, (error) => {
  // Ignore canceled requests (e.g., AbortController during component unmount)
  if (axios.isCancel(error)) {
    return Promise.reject(error)
  }

  const url = error.config?.url || 'API Request'
  const status = error.response?.status || 'Network Error'
  const message = error.response?.data?.error || error.message || 'Unknown Error'
  
  useLogStore.getState().addLog('error', `API [${status}] ${url}`, message)
  
  return Promise.reject(error)
})

export default api
